<template>
  <v-container fluid class="lighten-12 content">
    <v-data-table
              :fixed-header="true"
              :headers="waiterorders"
              :items="WaiterOrders"
              item-key="id"
              hide-default-footer
            >

            </v-data-table>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "Home",

  data: () => ({
    waiterorders:[
       {
        text: "Name",
        value: "waiter.name",
        show: true,
        disabled: true,

        width: "14%",
      },
      {
        text: "Reference Number",
        value: "waiter.reference_number",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    ],

    WaiterOrders:[],
  }),

  methods: {
      getWaiterOrders() {
      axios
        .get(
          `hms/dash-board/waiter-orders`
        )
        .then((resp) => {
          this.WaiterOrders = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },

  },
  created() {
    this.getWaiterOrders();
  },
};
</script>
<style scoped>
</style>
